import React from 'react';

export const functionalCalendarIcon = () => {
    return (
        <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_3014_628)">
                <path
                    d="M4.75 0.75C4.75 0.334375 4.41563 0 4 0C3.58437 0 3.25 0.334375 3.25 0.75V2H2C0.896875 2 0 2.89688 0 4V4.5V6V14C0 15.1031 0.896875 16 2 16H12C13.1031 16 14 15.1031 14 14V6V4.5V4C14 2.89688 13.1031 2 12 2H10.75V0.75C10.75 0.334375 10.4156 0 10 0C9.58437 0 9.25 0.334375 9.25 0.75V2H4.75V0.75ZM1.5 6H12.5V14C12.5 14.275 12.275 14.5 12 14.5H2C1.725 14.5 1.5 14.275 1.5 14V6Z"
                    fill="#4B5563"
                />
            </g>
            <defs>
                <clipPath id="clip0_3014_628">
                    <path d="M0 0H14V16H0V0Z" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
